export default __webpack_public_path__ + "static/media/check.c451759d.svg";